import React, { Component } from 'react';

export default class MapPoint extends Component {
  state = {
    pointNormal: {
      ...styles.container,
      background: '#ff5555ee'
    },
    point360: {
      ...styles.container,
      background: '#3489de'
    },
    point360Hover: {
      ...styles.container,
      background: '#3489de',
      transform: 'scale(1.5)'
    },
    point360Selected: {
      ...styles.container,
      background: '#33ff33',
      transform: 'scale(1.5)'
    },
    pointHover: {
      ...styles.container,
      background: '#ff3333',
      transform: 'scale(1.5)'
    },
    pointSelected: {
      ...styles.container,
      background: '#33ff33',
      transform: 'scale(1.5)'
    },
    hover: false
  };
  render() {
    const { pointData: data, selected } = this.props;
    const size = this.props.size || 12;
    let style;
    if (!data.is360) {
      style = this.state.hover
        ? this.state.pointHover
        : selected
          ? this.state.pointSelected
          : this.state.pointNormal;
    } else {
      style = this.state.hover
        ? this.state.point360Hover
        : selected
          ? this.state.point360Selected
          : this.state.point360;
    }

    return (
      <div
        style={{
          ...style,
          left: data.pos.x,
          top: data.pos.y,
          position: this.props.inline ? 'relative' : 'absolute',
          display: this.props.inline ? 'inline' : 'block'
        }}
        onMouseEnter={(() => {
          this.setState({ hover: true });
        }).bind(this)}
        onMouseLeave={(() => {
          this.setState({ hover: false });
        }).bind(this)}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          return this.props.onClick(data, e);
        }}
        onMouseDown={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
    );
  }
}

const styles = {
  container: {
    position: 'absolute',
    borderRadius: '100%',
    transformOrigin: 'center center',
    width: 10,
    height: 10,
    cursor: 'pointer',
    opacity: 0.75
  }
};



// WEBPACK FOOTER //
// ./src/components/MapPoint.js